import clsx from 'clsx'
import { useState } from 'react'

import { FvLinkButton, Icon } from '@fv/client-components'
import type { ShipmentShare } from '@fv/client-types'
import { fvDate } from '@fv/dates'

import { List, ListItem } from '@/components/List'
import { Pinline } from '@/components/Pinline'

import { getDeliveryStatusProps } from './share-utils'

type Props = {
  processingEmails?: string[]
  shares: ShipmentShare[]
  shareShipment: (emails: string[]) => void
}

export const ShareRecipientList = ({
  processingEmails,
  shares,
  shareShipment,
}: Props) => {
  const [shareStatusDisplay, setShareStatusDisplay] = useState(() => {
    const statusDisplay: { [key: string]: boolean } = {}

    shares.forEach(s => {
      statusDisplay[s.email] = false
    })

    return statusDisplay
  })

  return (
    <List fcp0>
      {shares.map(s => {
        const { icon, label } = getDeliveryStatusProps(s.status)
        const isResending = processingEmails?.includes(s.email)

        return (
          <ListItem key={s.email} className="flex-wrap">
            <FvLinkButton
              onClick={() => {
                setShareStatusDisplay(prev => ({
                  ...prev,
                  [s.email]: !prev[s.email],
                }))
              }}
              icon={icon}
            >
              {s.email}
            </FvLinkButton>

            {shareStatusDisplay[s.email] && (
              <>
                <Pinline className="my-2 w-full" dashed />

                <div className="flex items-center basis-full">
                  <div className="flex items-center">
                    <Icon
                      className={clsx({
                        'text-fv-green':
                          label === 'Delivered' || label === 'Sent',
                        'text-fv-orange': label === 'Failed',
                      })}
                      icon="envelope"
                    />

                    <span className="text-sm italic">
                      {label}{' '}
                      {fvDate(s.updatedAt).format('ddd MMM D [at] h:mm a')}
                    </span>
                  </div>
                  <Pinline className="flex-1 mx-2" dashed />
                  <FvLinkButton
                    className="ml-auto"
                    icon={isResending ? 'spinner' : 'paper-plane'}
                    onClick={() => {
                      if (isResending) return
                      shareShipment([s.email])
                    }}
                  >
                    Resend
                  </FvLinkButton>
                </div>
              </>
            )}
          </ListItem>
        )
      })}
    </List>
  )
}
